import React from 'react';
import css from './retry.svg.scss';

const RetrySvg = props => (
	<svg
		aria-describedby="desc"
		aria-labelledby="title"
		viewBox="0 0 64 64"
		className={css.svg}
		{...props}
	>
		<path
			className={css[props.type || 'path']}
			d="M3.3 22a3 3 0 0 1 4.2.8l2.5 3.6A27 27 0 0 1 36 6c14.6 0 26 12 26 26.6a26.4 26.4 0 0 1-45 18.7 3 3 0 1 1 4.2-4.3A20.4 20.4 0 0 0 56 32.6C56 21.3 47.2 12 36 12a21 21 0 0 0-20.3 16l4.4-4a3 3 0 0 1 4 4.5l-9.7 9-.3.2a2.8 2.8 0 0 1-.2.1l-.3.1a3 3 0 0 1-.2.2H13a3 3 0 0 1-.3.1h-1a3.1 3.1 0 0 1-.4 0l-.2-.2a2.9 2.9 0 0 1-.3-.1 2.8 2.8 0 0 1-.2-.2 2.8 2.8 0 0 1-.3-.2 2.9 2.9 0 0 1-.2-.2 3 3 0 0 1-.2-.2l-.1-.2-7.4-10.7a3 3 0 0 1 .8-4.2z"
			data-name="layer1"
		/>
	</svg>
);

export default RetrySvg;



// WEBPACK FOOTER //
// ./src/assets/svgr/retry/retry.svg.js